import {
  GetStaticProps,
  GetStaticPropsContext,
  InferGetStaticPropsType,
  NextPage,
} from 'next';

import {
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  FormDocument,
  FormQuery,
  FormQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
  SineStackSeoDocument,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import { Seo } from '@/components/Seo';

export const getStaticProps: GetStaticProps = async (
  context: GetStaticPropsContext,
) => {
  const client = initializeApollo();
  const { locale } = context;

  // prefetch
  await client.query({ query: NavigationDocument });
  await client.query({ query: SineStackSeoDocument });

  const { data: seoData } = await client.query({
    query: SineStackSeoDocument,
    variables: { locale: locale || 'en' },
  });

  const { data: formData } = await client.query<FormQuery, FormQueryVariables>({
    query: FormDocument,
    variables: { locale: locale || 'en' },
  });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument, variables: { locale: locale || 'en' } });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument, variables: { locale: locale || 'en' } });

  return addApolloState(client, {
    props: {
      seoData,
      formData,
      footerData,
      headerData,
    },
  });
};

const Contact: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  seoData,
  formData,
  footerData,
  headerData,
}) => (
  <Layout
    invertedColor
    formData={formData}
    footerData={footerData}
    headerData={headerData}
  >
    <Seo seo={seoData?.home?.data?.attributes?.seo} />
    {/* TODO: remove once the form component accepts props like isSingleElementOnPage for Contact page (to apply custom padding because of the fixed header) */}
    <div className="pointer-events-none h-[69px] w-full bg-[#6c7771]" />
  </Layout>
);

export default Contact;
